import { cn } from "@/lib/utils";

const Images = [
  ["Weather", "4x3", "col-span-4", "row-span-2"],
  ["GoogleEmails", "2x1", "col-span-2", "row-span-1"],
  ["Pomodoro", "2x2", "col-span-2", "row-span-2"],
  ["Time", "2x1", "col-span-2", "row-span-1"],
  ["TogglTimer", "4x2", "col-span-4", "row-span-2"],
  ["Calendar", "4x2", "col-span-4", "row-span-2"],
];

export const Grid = () => {
  return (
    <div className="relative flex h-full flex-col overflow-hidden font-lato">
      <div className="absolute left-0 top-36 grid grid-cols-8 gap-4 overflow-hidden">
        {Images.map(([name, size, col, row]) => (
          <img
            key={`${name}-${col}-${row}`}
            src={`/element-screenshots/${name}-${size}.png`}
            className={cn("w-full object-contain", col, row)}
          />
        ))}
      </div>
      <h2 className="z-10 mb-3 text-[36px]">Widgets That Work for You</h2>
      <h3 className="z-10 mb-5 text-[16px]">
        From tracking tasks to monitoring analytics, UniDeck gives you the
        flexibility to build your perfect workspace.
      </h3>
      <div className="absolute -bottom-1 left-0 h-[270px] w-full bg-gradient-to-b from-[#0A0A0A]/0 to-[#0A0A0A]/100" />
    </div>
  );
};
